module.exports = __webpack_public_path__ + "img/kids-3.c1f8a865.webp";